import { Link } from "react-router-dom";

const FEATURES = [
  { icon: "ri-home-5-line", title: "Fully Furnished Villas & Cottages", desc: "Move-in-ready luxury interiors." },
  { icon: "ri-tree-line", title: "Scenic Nature Views", desc: "Surrounded by lush forests." },
  { icon: "ri-fire-line", title: "Fire Pit & Lounge Areas", desc: "Cozy evening gathering spots." },
  { icon: "ri-water-flash-line", title: "Premium Resort Amenities", desc: "Resort-class facilities throughout." },
  { icon: "ri-wifi-line", title: "High-Speed Wi-Fi", desc: "Stay connected at all times." },
  { icon: "ri-parking-box-line", title: "Dedicated Parking", desc: "Secure space for your vehicle." },
  { icon: "ri-shield-keyhole-line", title: "24/7 Security", desc: "Round-the-clock protection." },
  { icon: "ri-flower-line", title: "Landscaped Gardens & Open Spaces", desc: "Beautiful outdoor environments." },
  { icon: "ri-briefcase-4-line", title: "Corporate Event Facilities", desc: "Built for conferences & retreats." },
  { icon: "ri-goblet-line", title: "Wedding & Celebration Venues", desc: "Breathtaking event locations." },
];

export default function Features() {
  return (
    <section id="resort" className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-14 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-vip-diamond-line"></i> Premium Resort Features
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
              Resort Living, <span className="italic text-primary-700">Elevated to Perfection</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Every villa and cottage sits within a professionally managed resort, giving you
              premium amenities and effortless ownership from day one.
            </p>

            <Link
              to="/resort"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
            >
              Tour the Resort Experience
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mt-8">
              {FEATURES.map((feature) => (
                <div
                  key={feature.title}
                  className="flex items-center gap-3 rounded-xl bg-background-100 border border-background-200 px-4 py-3"
                >
                  <span className="flex items-center justify-center w-9 h-9 rounded-full bg-secondary-100 text-secondary-900 shrink-0">
                    <i className={`${feature.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-[13px] font-bold text-foreground-950 leading-snug">{feature.title}</h4>
                    <p className="text-[11px] text-foreground-600 mt-0.5">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative grid grid-cols-2 gap-4">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20fire%20pit%20seating%20area%20outside%20a%20luxury%20A-frame%20cabin%20at%20night%20with%20warm%20glowing%20fire%20and%20forest%20trees%2C%20soft%20evening%20light%2C%20rustic%20luxury%20ambience%2C%20warm%20green%20and%20amber%20tones%2C%20premium%20resort%20photography&width=700&height=900&seq=feature-nomad-1&orientation=portrait"
              alt="Fire pit lounge area outside a luxury A-frame cabin at night"
              className="w-full h-64 md:h-96 object-cover object-top rounded-3xl"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Luxury%20resort%20swimming%20pool%20surrounded%20by%20pine%20forest%20with%20wooden%20deck%20loungers%20and%20umbrellas%2C%20clear%20turquoise%20water%2C%20sunny%20day%2C%20warm%20green%20landscape%2C%20premium%20hospitality%20photography&width=700&height=900&seq=feature-nomad-2&orientation=portrait"
              alt="Resort swimming pool surrounded by forest"
              className="w-full h-64 md:h-96 object-cover object-top rounded-3xl mt-8"
            />
          </div>
        </div>
      </div>
    </section>
  );
}